<input
  class="form-control input-custom-style"
  type="number"
  [(ngModel)]="data"
  onwheel="return false;"
  (input)="onInputChange($event)"
  (change)="updateCellRecord(data)"
  #inputField
/>
